export const CELEBRATE_CHECKOUT_KEY = 'dabble-celebrate-checkout';

/**
 * Checkout marks a just-completed activation here so the billing portal can
 * celebrate on arrival (sessionStorage survives the route change but not the
 * session — nobody gets confetti a week later).
 */
export function markCheckoutCelebration(selection: 'month' | 'year' | 'lifetime' | 'upgrade'): void {
  try {
    sessionStorage.setItem(CELEBRATE_CHECKOUT_KEY, selection);
  } catch {
    // Storage can be unavailable (private mode quotas); celebration is best-effort.
  }
}

/** Reads and clears the pending celebration, so it fires exactly once. */
export function consumeCheckoutCelebration(): string | null {
  try {
    const value = sessionStorage.getItem(CELEBRATE_CHECKOUT_KEY);
    if (value) sessionStorage.removeItem(CELEBRATE_CHECKOUT_KEY);
    return value;
  } catch {
    return null;
  }
}
